import * as R from 'ramda'

// @ts-ignore
export const isIE = /*@cc_on!@*/ false || !!document.documentMode

export const generateYearsArray = (range: number, top?: number) => {
	const upperLevel = top || new Date().getFullYear()
	return R.range(upperLevel - range, upperLevel + 1)
}